module.exports = __webpack_public_path__ + "img/constant.6f81b206.png";